module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAiCAYAAAAtZZsLAAAAAXNSR0IArs4c6QAAATVJREFUWAntmLENwjAQRf+FFBFCQBqqLMAEFEwAVCyRln2YgRaYAGjoGQBEhUSPAHMOAdEQJblDpLAlK5Hjbz9/3xUXMhsMYDDlHqF4O7JkQn3MikvzKcissS8J99yBcEENfephm2/LYrPIrBhP2G5X4HwCjHglgAgH4yHujLG0WJ6QLZHXfKDR1lgpOWREdw65tKkA2rWCgHv9tazsyTfxzgc1QIvUaALWTc2mCsjxg2aoiacUg59Ivo3H1ueI7F0li2UIX9SczSDE1QW03AypGoNfvCg/zNlcbUA+mgMsf79PpXPQOSh1QKp3MegclDog1bsYdA5KHZDqXQxKHZQVid05EA6zGc4LYDfKnpPx9fdXLPwfUu2iiZ39vYMZ15fnk2dLuzwT/zInKTu5OK4kZFq4PwDSVjWtQxN+BwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/file.png
// module id = 41M4
// module chunks = 41